module.exports = __webpack_public_path__ + "assets/img/bg-female-27f8c8c0.png";